import { render } from "./AppNavActions.vue?vue&type=template&id=8d10c110&ts=true"
import script from "./AppNavActions.vue?vue&type=script&lang=ts"
export * from "./AppNavActions.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__